module.exports = "<!-- Application Top Menu -->\n<!-- <top-menu></top-menu> -->\n<!-- Application Main Menu -->\n<!-- <main-menu [module]=\"module\"></main-menu> -->\n<!-- Process bar -->\n<!--<process-bar></process-bar>-->\n<!-- Application Content -->\n<router-outlet></router-outlet>\n<!-- Application Footer -->\n<!-- <footer></footer> -->";


//////////////////
// WEBPACK FOOTER
// ./src/bus/parent/AppComponent.html
// module id = 426
// module chunks = 0